import { useNavigate } from "react-router";

import { Chip, Divider, Skeleton, Stack, Typography } from "@mui/material";
import { useArcPlc } from "api-toolkit/useArcPlc";
import { formatNumber, formatPrice } from "utility/formatters";

import { TilleyCard } from "../../Cards/TilleyCard";
import { ArcPlcCardIcon, InfoIcon, WarningIcon } from "../../Icons/Icons";

export default function ArcPlcFarmCountyCard({ currentCounty, crop_year, arcCoCountyYieldOverrides = null }) {
  const navigate = useNavigate();

  const arcPlc = useArcPlc({
    baseAcres: currentCounty?.BaseAcres,
    crop_year,
    arcCoCountyYieldOverrides,
  });

  return (
    <TilleyCard
      data-testid={`arcplc-${currentCounty.location_county_name}-${currentCounty.location_state_name}`}
      onClick={() =>
        navigate(`/arcplc/${crop_year}/${currentCounty.location_state_name}/${currentCounty.location_county_name}`)
      }
      Avatar={ArcPlcCardIcon}
      title={
        <>
          {currentCounty?.location_county_name}, {currentCounty?.location_state_name}
        </>
      }
      subtitle={""}
      customContent={
        <Stack direction="column" spacing={2} className="custom-content">
          <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{formatNumber(currentCounty?.base_acreage, 0)}</Typography>
              <Typography variant="overline">BASE ACRES</Typography>
            </Stack>
          </Stack>

          <Divider sx={{ margin: "0px !important" }} />

          {!arcPlc?.isError &&
            (arcPlc?.totals?.arcPayment !== 0 || arcPlc?.totals?.plcPayment !== 0) &&
            Boolean(currentCounty?.BaseAcres?.length) && (
              <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
                <Stack direction="column" spacing={1}>
                  <Typography variant="overline" className="payment-heading">
                    ARC-CO PAYMENT
                  </Typography>
                  <Typography variant="subtitle2" data-testid="ARC-payment">
                    {!arcPlc?.isLoading && <>{formatPrice(arcPlc?.totals?.arcPayment, 0)}</>}
                    {arcPlc?.isLoading && <Skeleton data-testid="arc-payment-skeleton" />}
                  </Typography>
                </Stack>
                <Stack direction="column" spacing={1}>
                  <Typography variant="overline" className="payment-heading">
                    PLC PAYMENT
                  </Typography>
                  <Typography variant="subtitle2" data-testid="PLC-payment">
                    {!arcPlc?.isLoading && <>{formatPrice(arcPlc?.totals?.plcPayment, 0)}</>}
                    {arcPlc?.isLoading && <Skeleton data-testid="plc-payment-skeleton" />}
                  </Typography>
                </Stack>
              </Stack>
            )}

          {!currentCounty?.BaseAcres?.length && (
            <Chip data-testid="no-base-acres" className="no-payment" icon={<InfoIcon />} label="No base acres" />
          )}

          {!arcPlc?.isError && arcPlc?.totals?.arcPayment === 0 && arcPlc?.totals?.plcPayment === 0 && (
            <Chip
              data-testid="no-payments-projected"
              className="no-payment"
              icon={<InfoIcon />}
              label="No payments projected"
            />
          )}

          {arcPlc?.isError && (
            <Chip
              data-testid="unable-to-calculate-arc-plc-projections"
              className="warning no-payment"
              icon={<WarningIcon />}
              label="Unable to calculate ARC/PLC projections"
            />
          )}
        </Stack>
      }
      footer={currentCounty?.CropProfiles?.map((currentCropProfile, index) => (
        <Chip key={index} color="default" label={currentCropProfile?.commodity_name} />
      ))}
    />
  );
}
